import { ol_geom } from "@omnia/exports/openlayers"
import { convertGeometryToOpenLayers, Geometry2 } from "../geom"
import { isArray } from "../utils/utils"

/**
 * Describes coordinates as a "flat" array
 * Each entry in the outer array is a ring (the first being the exterior ring, all entries after that being interior rings)
 * Each entry in inner arrays provides the "flattened" coordinates, as [x1, y1, x2, y2, ...]
 * Those arrays must always have an even number of coordinates
 */
export type FlatPolygonCoordinates = number[][]

export function convertPolygonCoordsToOpenLayers(polygonCoords: FlatPolygonCoordinates) {

    const olCoords = polygonCoords.map(r => {

        const ringCoords = Array(r.length / 2)

        let j = 0

        for (let index = 0; index < r.length; index += 2) {
            ringCoords[j++] = [r[index], r[index + 1]]
        }

        return ringCoords

    })

    const polygon = new ol_geom.Polygon(olCoords)

    return polygon

}


export function getFlatCoordinatesIfPolygon(item: Geometry2) {

    if (isArray(item)) {
        return item
    }

    const geom = convertGeometryToOpenLayers(item)

    if (geom instanceof ol_geom.Polygon) {
        return getPolygonFlatCoordinates(geom)
    }

}


export function getPolygonFlatCoordinates(geom: ol_geom.Polygon) {
    const coordinates = geom.getCoordinates()
    return coordinates.map(ring => ring.flatMap(r => r))
}

export function isPolygonFlatCoordinatesArray(arg: any): arg is FlatPolygonCoordinates {
    // This is currently the only case when we are using arrays to describe geometries,
    // so this just checks if the argument is an array
    return isArray(arg)
}